import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as countryService from '@/services/countryService';

// ── Countries ───────────────────────────────────────────────────────

/** 国家列表 */
export function useCountries(params?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['countries', params],
    queryFn: () => countryService.getCountries(params),
  });
}

/** 创建国家 */
export function useCreateCountry() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: Record<string, unknown>) =>
      countryService.createCountry(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['countries'] });
    },
  });
}

/** 更新国家 */
export function useUpdateCountry() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      countryId,
      payload,
    }: {
      countryId: number;
      payload: Record<string, unknown>;
    }) => countryService.updateCountry(countryId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['countries'] });
    },
  });
}

/** 删除国家 */
export function useDeleteCountry() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (countryId: number) =>
      countryService.deleteCountry(countryId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['countries'] });
    },
  });
}

// ── Destinations ────────────────────────────────────────────────────

/** 目的地列表 */
export function useDestinations(params?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['destinations', params],
    queryFn: () => countryService.getDestinations(params),
  });
}

/** 创建目的地 */
export function useCreateDestination() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: Record<string, unknown>) =>
      countryService.createDestination(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['destinations'] });
    },
  });
}

/** 更新目的地 */
export function useUpdateDestination() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      destinationId,
      payload,
    }: {
      destinationId: number;
      payload: Record<string, unknown>;
    }) => countryService.updateDestination(destinationId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['destinations'] });
    },
  });
}

/** 删除目的地 */
export function useDeleteDestination() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (destinationId: number) =>
      countryService.deleteDestination(destinationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['destinations'] });
    },
  });
}
